import { render, staticRenderFns } from "./sweepings_report.vue?vue&type=template&id=4687b451"
import script from "./sweepings_report.vue?vue&type=script&lang=js"
export * from "./sweepings_report.vue?vue&type=script&lang=js"
import style0 from "./sweepings_report.vue?vue&type=style&index=0&id=4687b451&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports